import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Breadcrumb, Icon } from 'antd';
import { menus } from '@/router/menus';
import { findPathHierarchy } from '../../utils';

class BreadCrumb extends React.Component {

	createBreadCrumbData = (location, data) => {
		return findPathHierarchy(data, location.pathname);
	};

	render() {
		const { location } = this.props;
		const routes = this.createBreadCrumbData(location, menus);
		if (!routes.length) return null;
		const itemRender = (route, params, routes, paths) => {
			const last = routes.indexOf(route) === routes.length - 1;
			return (last || routes.indexOf(route) === 0) ? <span>{route.icon && <Icon type={route.icon} />} {route.title}</span> : <Link to={route.path}>{route.icon && <Icon type={route.icon} />} {route.title}</Link>;
		};
		return (
			<div className="breadCrumb">
				<Breadcrumb routes={routes} itemRender={itemRender} />
			</div>
		);
	}
}

export default withRouter(BreadCrumb);
